import * as fromState from './state.actions';
import { createReducer } from '@reduxjs/toolkit';
import { DeliveryAddress } from '../models/address';
import { IDeliveryZone } from '../models/organizationInfo/deliveryTerminal/deliveryZone.model';

export interface State {
  organizationCode: string;
  currentAddress: DeliveryAddress | null;
  currentZone: IDeliveryZone | null
}

export const initialState: State = {
  organizationCode: '',
  currentAddress: null,
  currentZone: null
};

export const stateReducer = createReducer(initialState, (builder) => {

  builder.addCase(fromState.setCurrentAddressAction, (state, action) => {
    return {
      ...state,
      organizationCode: action.payload.organizationCode,
      currentAddress: action.payload.deliveryAddress ? {
        ...action.payload.deliveryAddress
      } : null,
      currentZone: action.payload.deliveryZone ? {
        ...action.payload.deliveryZone
      } : null
    };
  });

  builder.addCase(fromState.updatingCurrentAddressAction, (state, action) => {
    return {
      ...state,
      currentAddress: action.payload.deliveryAddress ? {
        ...action.payload.deliveryAddress
      } : null,
      currentZone: action.payload.deliveryZone ? {
        ...action.payload.deliveryZone
      } : null
    };
  });

});
